import React, { useState } from "react";
import { Event } from "./index";
import CompletedEventCard from "./CompletedEventCard";
import "./styles/completed-events.css";
import moment from "moment";

const CompletedEvents = ({
  events,
  showGetNotifiedPopup,
  editMode,
  eventPath,
  showUpdateEventCoverPopup
}: {
  events: Event[];
  showGetNotifiedPopup: Function;
  editMode: boolean;
  eventPath: Function;
  showUpdateEventCoverPopup: Function;
}) => {
  const isPastEvent = (startDate: Date) => moment(startDate) < moment();
  return (
    <div className="container">
      <div className="completed-ev-container">
        {events.map(event => (
          <div key={event.id} className="completed-ev-card">
            <CompletedEventCard
              event={event}
              showGetNotifiedPopup={showGetNotifiedPopup}
              editMode={editMode && isPastEvent(event.startDate)}
              eventPath={eventPath}
              showUpdateEventCoverPopup={showUpdateEventCoverPopup}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default CompletedEvents;
